import { Message } from "simplydo/react/ui";

import util from "utils/utils";

const AiWarning = () => {
  return (
    <Message style={{ color: "grey" }} size="small">
      <span>
        Please remember that AI can make mistakes and that you should
        double-check results.{" "}
        <a
          href="https://support.simplydo.co.uk/hc/simplydo-help-center/articles/1754579836-ai-statement"
          target="_blank"
          style={{ textDecoration: "underline" }}
          rel="noopener noreferrer"
        >
          Learn more
        </a>
        {"  "}
        about how AI works on {util.appName()}.
      </span>
    </Message>
  );
};

export default AiWarning;
